// extracted by mini-css-extract-plugin
export default {"diffEntryHeader":"AutomatedReviewDiffEntry-module__diffEntryHeader--GNsEP","automatedReviewDiff":"AutomatedReviewDiffEntry-module__automatedReviewDiff--scQuw"};